import React from 'react';

import Title from '../Typography/Title';
import Description from '../Typography/Description';
import Button from '../Button';

import * as S from './style';

interface VacancyProps {
    title: string;
    id: string;
    description: string;
}

const VacancyItem: React.FC<VacancyProps> = ({ title, description, id }) => {
    return (
        <ul className="default">
            <S.VacancyItem>
                <S.VacancyItemText>
                    <Title margin={[0, 0, 8]} size="3.2" title={title} />
                    <Description description={description} />
                </S.VacancyItemText>
                <Button asLink path={`/careers/${id}`} className="btn-continue">Continua</Button>
            </S.VacancyItem>
        </ul>
    )
}

export default VacancyItem;